// product codes that allow custom codes to be sent
export const TXC_CODE = 'PD00000004'
export const TXC_PLUS_CODE = 'PD00000002'
export const TXC_PLUS_J_CODE = 'PD00000001'
export const TXC_PLUS_FALCON_CODE = 'PD00000015'
export const FOURGT_CODE = 'PD00000018'

export const CONTROL_TRIGGER_SCHEDULE_ALLOWED_PRODUCTS = [FOURGT_CODE, TXC_PLUS_FALCON_CODE]
export const UNIT_ACTIVATION_ALLOWED_PRODUCTS = [FOURGT_CODE]

export const PRODUCTS = [
  { code: TXC_CODE, product: 'TXC' },
  { code: TXC_PLUS_CODE, product: 'TXC+' },
  { code: TXC_PLUS_J_CODE, product: 'TXC+' },
  { code: TXC_PLUS_FALCON_CODE, product: 'Falcon' },
  { code: FOURGT_CODE, product: '4GT' }
]

export const productIsSupported = (productId: string, supportedProducts: string[]): boolean => {
  return supportedProducts.includes(productId)
}
